export default columns => {
  const grid = {};
  switch (columns) {
    case 1:
      grid.container = 8;
      grid.colSize = 12;
      break;
    case 2:
      grid.container = 8;
      grid.colSize = 6;
      break;
    case 3:
      grid.container = 10;
      grid.colSize = 4;
      break;
    case 4:
      grid.container = 10;
      grid.colSize = 3;
      break;
    default:
      return {};
  }
  return grid;
};
